import { Card, CardBody, CloseButton, Modal } from "react-bootstrap";
import { useStore } from "../../../hooks";
import { StoreModel } from "../../../models";
import { ChevronRight } from "react-bootstrap-icons";

type Props = {
  show: boolean;
  handleClose: () => void;
};

const ChangeStoreModal: React.FC<Props> = ({ show, handleClose }) => {
  const { storeId, storeLocations } = useStore();

  const isSelected = (location: StoreModel) => location.store_id === storeId;

  const handleClick = (location: StoreModel) => {
    console.log(`/olo/${location.store_id}`);
    window.location.href = `/olo/${location.store_id}`;

    // setStoreId(location.store_id);
    handleClose();
  };

  return (
    <>
      <Modal
        className="change_store modal-mobile-bottom"
        show={show}
        onHide={handleClose}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header className="flex-column align-items-start p-0">
          <CloseButton
            aria-label="Hide"
            className="position-absolute"
            variant="white"
            style={{ top: "15px", right: "15px", zIndex: 99 }}
            onClick={handleClose}
          />
          {storeLocations?.background_image && (
            <div
              className="position-relative w-100"
              style={{ borderRadius: "inherit" }}
            >
              <span className="overlay"></span>
              <img
                className="w-100"
                style={{
                  maxHeight: "150px",
                  objectFit: "cover",
                  borderRadius: "inherit",
                }}
                src={storeLocations?.background_image}
                alt=""
              />
            </div>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="text-uppercase mb-2">Choose an outlet</div>
          {storeLocations?.locations.map((location) => (
            <Card
              key={location.store_id}
              className={`store_location cursor-pointer mb-3 ${isSelected(location) ? "active" : ""}`}
              border={`${isSelected(location) ? "success" : ""}`}
              onClick={() => handleClick(location)}
            >
              <CardBody className="d-flex flex-row justify-content-between align-items-center">
                <span className="d-flex flex-column">
                  <span className="fw-bold">{location.store_name}</span>
                  <span className="text-muted">
                    <small>{location.store_address}</small>
                  </span>
                </span>
                <span>
                  <ChevronRight size={18} />
                </span>
              </CardBody>
            </Card>
          ))}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ChangeStoreModal;
